import {Hub, SandboxTree, StickerType, Tag} from 'yougile-model'
import {Util} from 'yougile-util'
import {StickerContainerKey, StickerHub} from '../views-web/a-sticker-view'

export abstract class AStickerCtl<V> {
  public get isSystem(): boolean {
    return false
  }

  public abstract get type(): StickerType
  public abstract displayedTitle(tag: Tag): string
  public abstract make(box: SandboxTree): Tag

  /**
   * Called when user pins sticker without value.
   * If action is required then this method is overloaded in child class.
   */
  public onPinEmpty(_1: Hub, _2: Tag, _container: StickerContainerKey): void {
    Util.noop()
  }

  /**
   * Called when user pins a sticker with any value.
   * If action is required then this method is overloaded in child class.
   */
  public onPin(_1: Hub, _2: Tag, _3: V): void {
    Util.noop()
  }

  /**
   * Called when user pins a sticker with any value.
   * If action is required then this method is overloaded in child class.
   */
  public onBeforePin(_task: StickerHub, _tag: Tag, _value: V): boolean {
    return true
  }
}
